import { ReactElement, useMemo, useState } from 'react';
import styles from './invites-banner.module.scss';
import { UIIcon, UIText } from '@/ui';
import { useInvites } from '../providers';
import { useCompaniesTranslation } from '../hooks';
import { InvitesModal } from './invites-modal';

export function InvitesBanner(): ReactElement {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { invites } = useInvites();

    const { t } = useCompaniesTranslation();

    const message = useMemo(
        () =>
            t('components.invites_banner.pending_count', {
                count: invites.length
            }),
        [invites.length, t]
    );

    if (invites.length === 0) return <></>;

    return (
        <>
            <button
                className={styles.container}
                onClick={() => {
                    setIsModalOpen(true);
                }}
            >
                <UIIcon name="send" size={18} color="white" />
                <UIText variant="semiLarge" type="white" bold>
                    {message}
                </UIText>
            </button>
            <InvitesModal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                }}
            />
        </>
    );
}
